// shared/pdf/fonts.js
// Import this file once in frontend/src/index.js.
// Backend registers fonts separately via registerFontsNode() in fontsNode.js.

import { Font } from '@react-pdf/renderer';
import NotoSansRegular from './assets/NotoSans-Regular.ttf';
import NotoSansBold from './assets/NotoSans-Bold.ttf';

export const registerFonts = () => {
  Font.register({
    family: 'NotoSans',
    fonts: [
      { src: NotoSansRegular, fontWeight: 'normal',  fontStyle: 'normal'  },
      { src: NotoSansBold,    fontWeight: 'bold',    fontStyle: 'normal'  },
      // No italic .ttf available — map italic to regular so React PDF never throws
      { src: NotoSansRegular, fontWeight: 'normal',  fontStyle: 'italic'  },
      { src: NotoSansBold,    fontWeight: 'bold',    fontStyle: 'italic'  },
    ],
  });
};
